import React from "react";
import FacebookIcon from "../svgs/Facebook.Orange.svg";
import InstagramIcon from "../svgs/Instagram.Orange.svg";
import TwitterIcon from "../svgs/Twitter.Orange.svg";
import LinkedInIcon from "../svgs/LinkedIn.Orange.svg";
import DataAndReportingIcon from "../svgs/data-and-reporting-icon.svg";
import DesktopAppIcon from "../svgs/desktop-app-icon.svg";
import WebsiteIcon from "../svgs/website-icon.svg";
import { pageWidths } from "../page-widths";
import { Link } from "react-router-dom";
import { CarouselProvider, Slider, Slide } from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import { Helmet } from "react-helmet";
import Banner from "../images/WebsiteBanner-100.jpg";
import "./Home.css";
import "./shared.css";

function Home() {
  const [width, setWidth] = React.useState(window.innerWidth);
  React.useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <main className="homePage">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Radix Software Solutions</title>
        <meta
          name="description"
          content="Consulting and reporting services with clear dashboards, reliable integrations, and automation that keeps data accurate."
        />
        <meta property="og:title" content="Radix Software Solutions" />
        <meta
          property="og:description"
          content="Consulting and reporting services with clear dashboards, reliable integrations, and automation that keeps data accurate."
        />
        <meta property="og:site_name" content="Radix Software Solutions" />
        <meta
          property="og:url"
          content="https://www.radixsoftwaresolutions.com/"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Radix Software Solutions" />
        <meta
          name="twitter:description"
          content="Consulting and reporting services with clear dashboards, reliable integrations, and automation that keeps data accurate."
        />
        <link rel="canonical" href="https://www.radixsoftwaresolutions.com/" />
      </Helmet>

      <section className="bannerSection" aria-label="Radix banner">
        <div
          className="bannerLarge"
          style={{
            backgroundImage: `url(${Banner})`,
            height:
              width > 1388
                ? "18em"
                : width > 800
                ? "16em"
                : width > 558
                ? "11em"
                : "8em",
            minHeight:
              width > 1388
                ? "20em"
                : width > 800
                ? "16em"
                : width > 558
                ? "11em"
                : "8em",
          }}
          hidden={width < 415}
        >
          <div className="bannerSocials">
            <a
              href="https://www.facebook.com/people/Radix-Software-Solutions/100088133167937/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                width={width > 800 ? "35px" : width > 558 ? "30px" : "25em"}
                src={FacebookIcon}
                alt="Radix Facebook"
                className="socialIcon"
              />
            </a>
            <a
              href="https://www.instagram.com/radix_software_solutions/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                width={width > 800 ? "35px" : width > 558 ? "30px" : "25em"}
                src={InstagramIcon}
                alt="Radix Instagram"
                className="socialIcon"
              />
            </a>
            <a
              href="https://twitter.com/Radix_Software"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                width={width > 800 ? "35px" : width > 558 ? "30px" : "25em"}
                src={TwitterIcon}
                alt="Radix Twitter"
                className="socialIcon"
              />
            </a>
            <a
              href="https://www.linkedin.com/company/radix-software-solutions-llc/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                width={width > 800 ? "35px" : width > 558 ? "30px" : "25em"}
                src={LinkedInIcon}
                alt="Radix LinkedIn"
                className="socialIcon"
              />
            </a>
          </div>
        </div>

        <div className="bannerSmall" hidden={width >= 415}>
          <img src={Banner} alt="Radix Software Solutions Banner" width="100%" />
          <div className="bannerSocialsCompact">
            <a
              href="https://www.facebook.com/people/Radix-Software-Solutions/100088133167937/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                width="25px"
                src={FacebookIcon}
                alt="Radix Facebook"
                className="socialIcon"
              />
            </a>
            <a
              href="https://www.instagram.com/radix_software_solutions/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                width="25px"
                src={InstagramIcon}
                alt="Radix Instagram"
                className="socialIcon"
              />
            </a>
            <a
              href="https://twitter.com/Radix_Software"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                width="25px"
                src={TwitterIcon}
                alt="Radix Twitter"
                className="socialIcon"
              />
            </a>
            <a
              href="https://www.linkedin.com/company/radix-software-solutions-llc/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                width="25px"
                src={LinkedInIcon}
                alt="Radix LinkedIn"
                className="socialIcon"
              />
            </a>
          </div>
        </div>
      </section>

      <section className="section heroSection" aria-label="Hero">
        <div className="pageContainer heroGrid">
          <div className="heroCopy">
            <p className="sectionKicker">Consulting + Reporting</p>
            <h1 className="heroTitle">
              Clear reporting, smart integrations, and automation for teams that
              need trustworthy data.
            </h1>
            <p className="paragraphTextStyle heroSubtitle">
              Radix Software Solutions helps growing businesses connect systems,
              streamline workflows, and build dashboards that make decisions
              easier.
            </p>
            <div className="heroActions">
              <Link className="ctaPrimary" to="/contact">
                Contact Us
              </Link>
              <Link className="ctaSecondary" to="/services">
                View Services
              </Link>
            </div>
          </div>
          <div className="heroCard card">
            <h2 className="cardTitle">What you get</h2>
            <ul className="heroList">
              <li>Executive dashboards that stay current.</li>
              <li>Integrations that keep data flowing end-to-end.</li>
              <li>Automation that removes manual work and errors.</li>
            </ul>
            <div className="heroNote">
              <span>Ready to modernize?</span>
              <Link className="heroLink" to="/contact">
                Start a project
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="section servicesSection" aria-label="Services">
        <div className="pageContainer">
          <div className="sectionHeader">
            <p className="sectionKicker">Services</p>
            <h2 className="headerTextStyle">Services</h2>
            <p className="paragraphTextStyle sectionLead">
              Focused consulting services that keep your reporting clean and
              your systems working together.
            </p>
          </div>
          <div className="grid servicesGrid">
            <article className="card serviceCard">
              <div className="serviceIconWrap">
                <img
                  src={DataAndReportingIcon}
                  alt="Reporting and dashboards icon"
                />
              </div>
              <h3 className="cardTitle">Reporting & Dashboards</h3>
              <p className="paragraphSnippetStyle serviceCopy">
                Executive-ready dashboards and scheduled reporting that surface
                the metrics you actually use.
              </p>
            </article>
            <article className="card serviceCard">
              <div className="serviceIconWrap">
                <img src={WebsiteIcon} alt="Systems integration icon" />
              </div>
              <h3 className="cardTitle">Integrations</h3>
              <p className="paragraphSnippetStyle serviceCopy">
                Connect APIs, databases, and SaaS tools so your data flows
                without manual handoffs.
              </p>
            </article>
            <article className="card serviceCard">
              <div className="serviceIconWrap">
                <img src={DesktopAppIcon} alt="Automation icon" />
              </div>
              <h3 className="cardTitle">Automation</h3>
              <p className="paragraphSnippetStyle serviceCopy">
                Reduce repetitive work with scripts, workflows, and triggers
                that keep teams moving.
              </p>
            </article>
            <article className="card serviceCard">
              <div className="serviceInitial">DC</div>
              <h3 className="cardTitle">Data Cleanup</h3>
              <p className="paragraphSnippetStyle serviceCopy">
                Standardize messy datasets, deduplicate records, and repair
                broken fields before they hit your reports.
              </p>
            </article>
          </div>
          <div className="sectionFooter">
            <Link className="ctaSecondary" to="/services">
              Explore services
            </Link>
          </div>
        </div>
      </section>

      <section className="section featuredToolSection" aria-label="Featured tool">
        <div className="pageContainer">
          <div className="sectionHeader">
            <p className="sectionKicker">Featured Tool</p>
            <h2 className="headerTextStyle">Featured Tool</h2>
            <p className="paragraphTextStyle sectionLead">
              A Radix-built resource that helps teams make quick, confident
              decisions.
            </p>
          </div>
          <div className="card featuredToolCard">
            <div>
              <h3 className="cardTitle">CalcStacks</h3>
              <p className="paragraphTextStyle featuredToolCopy">
                Practical calculators for real-world decisions - built by Radix
                Software Solutions LLC.
              </p>
            </div>
            <div className="featuredToolActions">
              <a
                className="ctaPrimary"
                href="https://calcstacks.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Visit CalcStacks
              </a>
              <Link className="ctaSecondary" to="/tools">
                See all tools
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="section howWeWorkSection" aria-label="How we work">
        <div className="pageContainer">
          <div className="sectionHeader">
            <p className="sectionKicker">How we work</p>
            <h2 className="headerTextStyle">How we work</h2>
            <p className="paragraphTextStyle sectionLead">
              A simple, collaborative process designed for clarity and speed.
            </p>
          </div>
          <div className="grid workGrid">
            <article className="card workCard">
              <p className="workStep">01</p>
              <h3 className="cardTitle">Discover</h3>
              <p className="paragraphSnippetStyle workCopy">
                We map your data sources, reporting needs, and success metrics.
              </p>
            </article>
            <article className="card workCard">
              <p className="workStep">02</p>
              <h3 className="cardTitle">Design</h3>
              <p className="paragraphSnippetStyle workCopy">
                We build the integration and reporting plan with clear
                milestones.
              </p>
            </article>
            <article className="card workCard">
              <p className="workStep">03</p>
              <h3 className="cardTitle">Deliver</h3>
              <p className="paragraphSnippetStyle workCopy">
                We launch, validate, and refine until the insights are ready to
                use.
              </p>
            </article>
          </div>
        </div>
      </section>

      <section className="section featuredClientsSection" aria-label="Featured clients">
        <div className="pageContainer">
          <div className="sectionHeader">
            <p className="sectionKicker">Featured Clients</p>
            <h2 className="headerTextStyle">Featured Clients</h2>
          </div>
        </div>

        <div
          className="featuredClientsWrapper"
          hidden={width >= pageWidths.smallWidth}
        >
          <CarouselProvider
            naturalSlideWidth={100}
            naturalSlideHeight={125}
            totalSlides={3}
            orientation={"horizontal"}
            isIntrinsicHeight={true}
            visibleSlides={1}
            isPlaying={true}
            infinite={true}
            interval={4000}
            step={1}
            playDirection={"forward"}
          >
            <Slider>
              <Slide index={0}>
                <div className="moibleServiceSection">
                  <a
                    href="https://topshelfmeats.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div
                      className="serviceHover serviceImageContainer"
                      style={{ backgroundColor: "black" }}
                    >
                      <img
                        width="100%"
                        src="https://rss-web-images.s3.us-east-2.amazonaws.com/images/Browns-TopShelf-Meats_logo.png"
                        alt="Top Shelf Meats Badge"
                      />
                    </div>
                  </a>
                  <p
                    className="paragraphSnippetStyle centerParagraph"
                    style={{ color: "white" }}
                  >
                    <i>
                      ...Very personable, clear to understand, and has great
                      ideas to help. Highly recommend Nathan and Radix!
                    </i>
                  </p>
                </div>
              </Slide>
              <Slide index={1}>
                <div className="moibleServiceSection">
                  <a
                    href="https://backroadpicking.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="serviceHover serviceImageContainer">
                      <img
                        width="100%"
                        src="https://rss-web-images.s3.us-east-2.amazonaws.com/images/Badge5.Main.png"
                        alt="Back Road Picking Badge"
                      />
                    </div>
                  </a>
                  <p
                    className="paragraphSnippetStyle centerParagraph"
                    style={{ color: "white" }}
                  >
                    <i>
                      Nathan and team took us from a blank slate to a full blown
                      site that we love ... You won{"'"}t go wrong working with
                      Radix.
                    </i>
                  </p>
                </div>
              </Slide>
              <Slide index={2}>
                <div className="moibleServiceSection">
                  <a
                    href="https://paperwishes.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="serviceHover">
                      <img
                        width="100%"
                        src="https://rss-web-images.s3.us-east-2.amazonaws.com/images/PaperWishes.png"
                        alt="Paper Wishes Badge"
                      />
                    </div>
                  </a>
                  <p
                    className="paragraphSnippetStyle centerParagraph"
                    style={{ color: "white" }}
                  >
                    <i>
                      ...I wouldn{"'"}t hesitate recommending Nathan and Radix.
                      I know he will be our go to for any future needs.
                    </i>
                  </p>
                </div>
              </Slide>
            </Slider>
          </CarouselProvider>
        </div>

        <div
          className="featuredClientsWrapper"
          hidden={width < pageWidths.smallWidth}
        >
          <div className="featuredClientsGrid">
            <div className="serviceSection" style={{ backgroundColor: "#064860" }}>
              <a
                href="https://topshelfmeats.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div
                  className="serviceHover serviceImageContainer"
                  style={{ backgroundColor: "black" }}
                >
                  <img
                    width="60%"
                    src="https://rss-web-images.s3.us-east-2.amazonaws.com/images/Browns-TopShelf-Meats_logo.png"
                    alt="Top Shelf Meats Badge"
                  />
                </div>
              </a>
              <p
                className="paragraphSnippetStyle centerParagraph"
                style={{ color: "white" }}
              >
                <i>
                  ...Very personable, clear to understand, and has great ideas
                  to help. Highly recommend Nathan and Radix!
                </i>
              </p>
            </div>

            <div className="serviceSection" style={{ backgroundColor: "#064860" }}>
              <a
                href="https://backroadpicking.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="serviceHover serviceImageContainer">
                  <img
                    width="100%"
                    src="https://rss-web-images.s3.us-east-2.amazonaws.com/images/Badge5.Main.png"
                    alt="Back Road Picking Badge"
                  />
                </div>
              </a>
              <p
                className="paragraphSnippetStyle centerParagraph"
                style={{ color: "white" }}
              >
                <i>
                  Nathan and team took us from a blank slate to a full blown
                  site that we love ... You won{"'"}t go wrong working with
                  Radix.
                </i>
              </p>
            </div>

            <div className="serviceSection" style={{ backgroundColor: "#064860" }}>
              <a
                href="https://paperwishes.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="serviceHover serviceImageContainer">
                  <img
                    width="65%"
                    src="https://rss-web-images.s3.us-east-2.amazonaws.com/images/PaperWishes.png"
                    alt="Paper Wishes Badge"
                  />
                </div>
              </a>
              <p
                className="paragraphSnippetStyle centerParagraph"
                style={{ color: "white" }}
              >
                <i>
                  ...I wouldn{"'"}t hesitate recommending Nathan and Radix. I
                  know he will be our go to for any future needs.
                </i>
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Home;
